/** API client for the attention (Home) summary endpoint (UX spec §3.8). */

import { get } from './client.ts'
import type { AttentionSummary } from '../types/attention.ts'

export function getAttentionSummary(): Promise<AttentionSummary> {
  return get<AttentionSummary>('/attention/summary')
}
